import { defineStore } from 'pinia';

export const useNavigationStore = defineStore('UseNavigationStore', () => {
	const isHeaderVisible = shallowRef<boolean>(true);
	const isContextualHeaderVisible = shallowRef<boolean>(false);
	const hasContextualHeader = shallowRef<boolean>(true);
	// Mobile
	const isMobileMenuOpen = shallowRef<boolean>(false);
	const isMobileProfileMenuOpen = shallowRef<boolean>(false);
	// Desktop
	const isNavigationMenuOpen = shallowRef(false);
	const isProfileNavigationMenuOpen = shallowRef(false);

	const headerVariant = shallowRef<'translucide' | 'primary'>('translucide');
	const propertyListSectionScrollY = shallowRef<number>(0);

	function setIsHeaderVisible(value: boolean) {
		isHeaderVisible.value = value;
	}

	function setIsContextualHeaderVisible(value: boolean) {
		isContextualHeaderVisible.value = value;
	}

	function setHasContextualHeader(value: boolean) {
		hasContextualHeader.value = value;
	}

	function setIsMobileMenuOpen(value: boolean) {
		isMobileMenuOpen.value = value;
	}

	function setIsMobileProfileMenuOpen(value: boolean) {
		isMobileProfileMenuOpen.value = value;
	}

	function setIsNavigationMenuOpen(value: boolean) {
		isNavigationMenuOpen.value = value;
	}

	function setIsProfileNavigationMenuOpen(value: boolean) {
		isProfileNavigationMenuOpen.value = value;
	}

	function setHeaderVariant(value: 'translucide' | 'primary') {
		headerVariant.value = value;
	}

	function setPropertyListSectionScrollY(value: number) {
		propertyListSectionScrollY.value = value;
	}

	function closeMenus() {
		setIsMobileMenuOpen(false);
		setIsMobileProfileMenuOpen(false);
	}

	const isMenuMobileOpen = computed(
		() => isMobileMenuOpen.value || isMobileProfileMenuOpen.value
	);

	const isMenuOpen = computed(
		() =>
			isNavigationMenuOpen.value ||
			isProfileNavigationMenuOpen.value ||
			isMenuMobileOpen.value
	);

	return {
		isHeaderVisible,
		setIsHeaderVisible,
		isContextualHeaderVisible,
		setIsContextualHeaderVisible,
		hasContextualHeader,
		setHasContextualHeader,
		isMobileMenuOpen,
		isMobileProfileMenuOpen,
		isNavigationMenuOpen,
		isProfileNavigationMenuOpen,
		isMenuMobileOpen,
		isMenuOpen,
		headerVariant,
		propertyListSectionScrollY,
		setHeaderVariant,
		setIsMobileMenuOpen,
		setIsMobileProfileMenuOpen,
		setIsNavigationMenuOpen,
		setIsProfileNavigationMenuOpen,
		closeMenus,
		setPropertyListSectionScrollY
	};
});
